import { css } from "styled-components";

const poppins_caption_base = css`
  font-family: var(--font-poppins);
  font-style: normal;
  letter-spacing: -0.012rem;
`;

export const poppins_caption_lg_bold = css`
  ${poppins_caption_base};
  font-size: var(--text-caption-size-lg);
  font-weight: var(--text-weight-bold);
  line-height: 1.43rem;
`;

export const poppins_caption_lg_semibold = css`
  ${poppins_caption_base};
  font-size: var(--text-caption-size-lg);
  font-weight: var(--text-weight-semibold);
  line-height: 1.43rem;
`;

export const poppins_caption_lg_medium = css`
  ${poppins_caption_base};
  font-size: var(--text-caption-size-lg);
  font-weight: var(--text-weight-medium);
  line-height: 1.43rem;
`;

export const poppins_caption_lg_regular = css`
  ${poppins_caption_base};
  font-size: var(--text-caption-size-lg);
  font-weight: var(--text-weight-regular);
  line-height: 1.43rem;
`;

export const poppins_caption_md_bold = css`
  ${poppins_caption_base};
  font-size: var(--text-caption-size-md);
  font-weight: var(--text-weight-bold);
  line-height: 1.3rem;
`;

export const poppins_caption_md_semibold = css`
  ${poppins_caption_base};
  font-size: var(--text-caption-size-md);
  font-weight: var(--text-weight-semibold);
  line-height: 1.3rem;
`;

export const poppins_caption_md_medium = css`
  ${poppins_caption_base};
  font-size: var(--text-caption-size-md);
  font-weight: var(--text-weight-medium);
  line-height: 1.3rem;
`;

export const poppins_caption_md_regular = css`
  ${poppins_caption_base};
  font-size: var(--text-caption-size-md);
  font-weight: var(--text-weight-regular);
  line-height: 1.3rem;
`;
